// extracted by mini-css-extract-plugin
module.exports = {"container":"CalculatingIncidenceRate_container__3z6oD","title":"CalculatingIncidenceRate_title__3aOx3","description":"CalculatingIncidenceRate_description__3zsTM"};